/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod"

/**
 * Возвращает флаги доступа, баланс маркетинговых SMS, лимит на рассылку и часовой пояс.
Вызывается при входе в раздел «Маркетинг». Бизнесы определяются автоматически из JWT-токена.

 * @summary Контекст маркетинга для организации
 */
export const GetMarketingContextResponse = zod.object({
	marketingEnabled: zod.boolean(),
	marketingAccepted: zod
		.boolean()
		.optional()
		.describe("Пользователь принял условия маркетинга"),
	marketingSmsBalance: zod.number().describe("Остаток маркетинговых SMS"),
	sendLimit: zod.number().describe("Лимит получателей на одну рассылку"),
	defaultTimezone: zod.string(),
})

/**
 * Фиксирует согласие пользователя с условиями маркетинга для всех бизнесов организации.
Аналог установки `marketingNotifications.accepted` в desktop-backoffice.

 * @summary Принять условия использования маркетинговых рассылок
 */
export const AcceptMarketingTermsResponse = zod.object({
	marketingEnabled: zod.boolean(),
	marketingAccepted: zod
		.boolean()
		.optional()
		.describe("Пользователь принял условия маркетинга"),
	marketingSmsBalance: zod.number().describe("Остаток маркетинговых SMS"),
	sendLimit: zod.number().describe("Лимит получателей на одну рассылку"),
	defaultTimezone: zod.string(),
})

/**
 * Справочник часовых поясов РФ для выбора в блоке «Запуск».
Может кэшироваться на клиенте.

 * @summary Список часовых поясов для планировщика
 */
export const getMarketingTimezonesResponseTimezonesItemIsBusinessDefaultDefault = false

export const GetMarketingTimezonesResponse = zod.object({
	timezones: zod.array(
		zod.object({
			id: zod.string().describe("IANA timezone"),
			label: zod.string(),
			offset: zod.string(),
			isBusinessDefault: zod
				.boolean()
				.default(
					getMarketingTimezonesResponseTimezonesItemIsBusinessDefaultDefault,
				),
		}),
	),
})
